import { getParser } from "bowser"

const browser = getParser(window.navigator.userAgent)

export const isVideoCallsUnsupported = browser.satisfies({
    safari: ">0",
})
